import React from 'react';
import { Link } from 'react-router-dom';
import { Globe2, Building2, Check, ArrowRight } from 'lucide-react';

export const globalSolutionCards = [
  {
    icon: <Globe2 className="w-7 h-7" />,
    titleEn: 'Global Expansion',
    titleJa: '海外進出支援',
    description: '日本企業が自信を持って海外のお客様へ届くよう、一歩ずつ支援します。',
    services: [
      '国際ブランディング（International Branding）',
      '英語サイト制作（English Website Creation）',
      '海外向けEC（Global E-commerce）',
      'AI商品マーケティング（AI Product Marketing）',
      '海外SEO（International SEO）',
      'Google・Meta広告（Google & Meta Advertising）',
      '輸出マーケティング戦略（Export Marketing Strategy）',
    ],
    link: '/services/global-expansion',
  },
  {
    icon: <Building2 className="w-7 h-7" />,
    titleEn: 'Japan Market Entry',
    titleJa: '日本市場進出支援',
    description: '海外企業が日本市場へスムーズに参入し、成長できるよう支援します。',
    services: [
      '日本語サイトローカライズ（Website Localization）',
      '日本語翻訳（Japanese Translation）',
      '日本向けSEO（SEO for Japan）',
      'Googleビジネスプロフィール（Google Business Profile）',
      'LINE公式アカウント開設（LINE Official Account）',
      '日本向けSNSマーケティング（SNS Marketing for Japan）',
      '販売代理店・パートナー開拓（Distributor & Partner Outreach）',
      'カスタマーサポート戦略（Customer Support Strategy）',
    ],
    link: '/services/japan-market-entry',
  },
];

const GlobalSolutions = ({ background = '#FFF7FA' }) => {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: background }} data-testid="global-solutions-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-14 fade-in">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full bg-white" style={{ color: '#C77A93' }}>
            Global Business Solutions
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-5" style={{ color: '#2C2C2C' }}>
            日本と世界を、ビジネスでつなぐ
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Connecting Japan and the World.<br className="hidden md:inline" />
            バイリンガル対応、AIを活用したマーケティング、DX、戦略的な市場参入支援を通じて、
            国境を越えたビジネスの成長をお手伝いします。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {globalSolutionCards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl border border-gray-100 shadow-sm hover-lift p-8 md:p-10 flex flex-col"
              data-testid={`global-solution-card-${index}`}
            >
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ backgroundColor: '#FFF7FA', color: '#C77A93' }}>
                {card.icon}
              </div>
              <p className="text-sm font-medium tracking-wide mb-1" style={{ color: '#C77A93' }}>
                {card.titleEn}
              </p>
              <h3 className="text-2xl font-bold mb-3" style={{ color: '#2C2C2C' }}>
                {card.titleJa}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {card.description}
              </p>
              <ul className="space-y-3 mb-8 flex-grow">
                {card.services.map((service, i) => (
                  <li key={i} className="flex items-start">
                    <Check className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0" style={{ color: '#C77A93' }} />
                    <span className="text-gray-700 text-sm">{service}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={card.link}
                className="btn-primary inline-flex items-center justify-center px-6 py-3 rounded-full font-medium text-sm self-start"
                data-testid={`global-solution-link-${index}`}
              >
                Learn More
                <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalSolutions;
